import React from 'react';
import ArticleField from '../ArticleField';
import { Switch } from '@material-ui/core';

interface SeeInMostViewProps {
    value: boolean,
    onChange: (value: boolean) => void
}

const SeeInMostView = (props: SeeInMostViewProps) => (
    <ArticleField label="Voir dans les plus lus">
        <Switch checked={props.value} onChange={(e) => {
            props.onChange(e.target.checked);
        }} />
    </ArticleField >
)

export default SeeInMostView;